import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Régimen tributario de la empresa (14d3, 14d8, …) y si es de un empresario individual,
 * leídos del servidor y no de la empresa guardada en el navegador, que puede ser
 * anterior a un cambio en Datos de la empresa. Con ellos la renta abre el módulo que
 * corresponde sin preguntarlo. La lista de regímenes está en
 * services/regimenesTributarios.js.
 *
 * @param {number} idCompany
 * @param {string} token
 * @returns {{ regimen: string|null, empresarioIndividual: boolean, cargando: boolean }}
 */
const useRegimenEmpresa = (idCompany, token) => {
    const [regimen, setRegimen] = useState(null);
    const [empresarioIndividual, setEmpresarioIndividual] = useState(false);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        if (!idCompany || !token) return undefined;
        let vigente = true;
        setCargando(true);
        axios.get(`${API_BASE_URL}/api/company/companies/${idCompany}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((response) => {
                if (!vigente) return;
                setRegimen(response.data.regimen_tributario || null);
                setEmpresarioIndividual(response.data.empresario_individual === true);
            })
            .catch((error) => {
                console.error('Error al obtener el régimen tributario de la empresa:', error);
                if (vigente) {
                    setRegimen(null);
                    setEmpresarioIndividual(false);
                }
            })
            .finally(() => { if (vigente) setCargando(false); });
        return () => { vigente = false; };
    }, [idCompany, token]);

    return { regimen, empresarioIndividual, cargando };
};

export default useRegimenEmpresa;
